/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Draft` - Draft
 * * `InProgress` - InProgress
 * * `Live` - Live
 * * `Closeout` - Closeout
 */
export enum PhaseEnum {
    DRAFT = 'Draft',
    IN_PROGRESS = 'InProgress',
    LIVE = 'Live',
    CLOSEOUT = 'Closeout',
}
